<template>
	<div class="zoom">
		<div class="zoom__header">
			<i class="icon-arrow_right hide"></i>
			이미지 확대
			<i
				class="icon-close"
				@click="$emit('onClose')"
			></i>
		</div>
		<div class="zoom__img">
			<img
				:src="img"
				alt="img"
				id="zoomable-image"
			/>
		</div>
	</div>
</template>

<script>
import { onMounted } from 'vue';
import PinchZoom from 'pinch-zoom-js';
export default {
	props: {
		img: {
			required: true,
			type: String,
		},
	},
	setup() {
		let zoomableImage;

		onMounted(() => {
			zoomableImage = document.getElementById(
				'zoomable-image'
			);
			new PinchZoom(zoomableImage, {
				draggableUnzoomed: false,
				maxZoom: 3,
			});
		});
	},
};
</script>

<style lang="scss" scoped>
.zoom {
	position: fixed;
	top: 0;
	left: 0;
	width: 100vw;
	height: 100vh;
	margin-top: $DheaderH;
	display: flex;
	flex-direction: column;
	z-index: 50;
	transition: all 0.3s;
	overflow: hidden;
	&__header {
		position: fixed;
		z-index: 10;
		top: $DheaderH;
		left: 0;
		width: 100%;
		display: flex;
		justify-content: space-between;
		background: $gray7;
		align-items: center;
		@include BodyLB($gray0);
		height: 50px;
		i {
			width: 24px;
			color: $gray0;
			font-size: 24px;
			padding: 13px 20px;
			&.hide {
				opacity: 0;
			}
		}
	}
	&__img {
		margin-top: 50px;
		width: 100%;
		background: $gray9;
		flex: 1;
		align-items: center;
		justify-content: center;
		display: flex;
		img {
			width: 100%;
		}
	}
}
// 태블릿
@media screen and (max-width: $tabletW) {
	.zoom {
		margin-top: $TheaderH;
		&__header {
			top: $TheaderH;
			@include BodyMB($gray0);
		}
	}
}

// 모바일
@media screen and (max-width: $mobileW) {
	.zoom {
		margin-top: $MheaderH;
		&__header {
			top: $MheaderH;
			height: 40px;
			@include BodySB($gray0);
			i {
				padding: 6px 20px;
			}
		}
		&__img {
			margin-top: 40px;
		}
	}
}
</style>
<style>
.pinch-zoom-container {
	width: 100%;
}
</style>
